import React from "react";
import { reduce } from "lodash";
import { Range } from "rc-slider";
import { Glyph } from "@ui-kit/icon";
import RangeStyle from "./styled";

export type Mark = {
  id: string | React.ReactElement;
  glyph?: Glyph;
  min?: number;
  max?: number;
};

interface IProps {
  marks: Mark[];
  range: number[];
  onChange: (range: number[]) => void;
  renderMark?: (mark: Mark) => void;
  className?: string;
}

const formatRange = (range: number[], marks: Mark[]) => [
  marks[range[0]].min,
  marks[range[1]].max,
];

const UiKitFormSlider = ({
  marks,
  range,
  onChange,
  renderMark,
  className,
}: IProps) => {
  const start = marks.findIndex(
    (m) => m.min === range[0] || m.max === range[0]
  );
  const end = marks.findIndex((m) => m.min === range[1] || m.max === range[1]);

  return (
    <div className={className}>
      <RangeStyle />
      <Range
        min={0}
        max={marks.length - 1}
        marks={reduce(
          marks,
          (acc, mark, idx) => {
            acc[idx] = renderMark ? renderMark(mark) : mark.id;
            return acc;
          },
          {}
        )}
        onChange={(range) => onChange(formatRange(range, marks))}
        value={[start, end]}
      />
    </div>
  );
};

export default UiKitFormSlider;
